var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 140,
    viewBox: "0 0 144 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1944 123.608C27.3168 123.608 0 96.272 0 62.1438V61.8042C0 27.6761 27.6582 0 64.5359 0C101.414 0 128.73 27.3365 128.73 61.4646V61.8042C128.73 95.9324 101.072 123.608 64.1944 123.608ZM64.5359 93.8949C82.804 93.8949 94.9258 79.2928 94.9258 62.1438V61.8042C94.9258 44.6553 82.4625 29.7136 64.1944 29.7136C46.0971 29.7136 33.9753 44.3157 33.9753 61.4646V61.8042C33.9753 78.9532 46.4385 93.8949 64.5359 93.8949Z",
    fill: "#4A59FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.479 140C105.65 140 95.0859 129.812 95.0859 116.887V116.76C95.0859 103.834 105.778 93.5195 119.607 93.5195C133.436 93.5195 144 103.707 144 116.632V116.76C144 129.685 133.308 140 119.479 140ZM119.607 126.82C125.305 126.82 128.89 122.108 128.89 116.887V116.76C128.89 111.475 125.241 106.7 119.479 106.7C113.781 106.7 110.195 111.411 110.195 116.632V116.76C110.195 122.044 113.845 126.82 119.607 126.82Z",
    fill: "#4A59FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.346 115.763L79.5169 81.0616H92.3216L98.9801 101.182L105.639 81.0616H118.251L104.422 115.763H93.346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.26d1fe69eb8d592c76ec48e88e3568c6.svg";
export { ForwardRef as ReactComponent };